// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"957c8a28","817":"e4ee04ac","863":"aa062d96","900":"c0690c6d"}[chunkId] + ".chunk.css";
};